import { ReactNode } from 'react'
import { Topbar } from '../components/TopBar'

interface MainLayoutProps {
    children: ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
    return (
        <>
            <Topbar />

            <main>
                {children}
            </main>
        </>
    )
}